/**
 * @generated SignedSource<<9544a68f02917c5ee20d0703e2ca970a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type dispatchConditionDropdown_Refetch$variables = {
  id: string;
};
export type dispatchConditionDropdown_Refetch$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"dispatchConditionDropdown_MessageDispatchFragment">;
  } | null;
};
export type dispatchConditionDropdown_Refetch = {
  response: dispatchConditionDropdown_Refetch$data;
  variables: dispatchConditionDropdown_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isDispatchCondition"
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootNodeIds",
    "storageKey": null
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AccountDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AllUserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "type": "UserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeStartedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeFinishedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeUnlockedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "OptInDispatchCondition",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dispatchConditionDropdown_Refetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "dispatchConditionDropdown_MessageDispatchFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dispatchConditionDropdown_Refetch",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "includes",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "excludes",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "type": "MessageDispatch",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4f810e3494fe89030ba4c2704bd30401",
    "id": null,
    "metadata": {},
    "name": "dispatchConditionDropdown_Refetch",
    "operationKind": "query",
    "text": "query dispatchConditionDropdown_Refetch(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...dispatchConditionDropdown_MessageDispatchFragment\n    id\n  }\n}\n\nfragment dispatchConditionDropdown_MessageDispatchFragment on MessageDispatch {\n  id\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n}\n\nfragment removeDispatchConditionButton_DispatchConditionFragment on DispatchCondition {\n  __isDispatchCondition: __typename\n  id\n}\n"
  }
};
})();

(node as any).hash = "05e9a1ad43ce5afc58e1753472f4c08b";

export default node;
